import React, { ComponentProps, PropsWithChildren } from 'react'
import styled from 'styled-components'

import SvgIcon from 'components/Luxkit/SvgIcon'

const StyledSvg = styled(SvgIcon)`
  pointer-events: none;
  overflow: visible;
  width: 100%;
  height: 100%;

  & > path {
    pointer-events: stroke;
    cursor: pointer;
  }
`

export default function ClickableStroke({
  children,
  ...props
}: PropsWithChildren<ComponentProps<typeof SvgIcon>>) {
  return <StyledSvg {...props}>{children}</StyledSvg>
}
